import {PropsWithChildren, HTMLAttributes} from 'react';

export const Card = ({
  styleClasses,
  children,
  ...props
}: {styleClasses?: string} & PropsWithChildren &
  HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={`bg-white [border-radius:var(--carina-border-radius-xl)] flex flex-col flex-wrap ${styleClasses}`}
      style={{
        boxShadow:
          '0 1px 2px -1px rgba(0, 0, 0, 0.10), 0 1px 3px 0 rgba(0, 0, 0, 0.10)',
        backgroundColor: '#fff',
      }}
    >
      {children}
    </div>
  );
};
